import { render, staticRenderFns } from "./UCheckbox.vue?vue&type=template&id=2b21cac2&scoped=true"
import script from "./UCheckbox.vue?vue&type=script&lang=js"
export * from "./UCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UCheckbox.vue?vue&type=style&index=0&id=2b21cac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b21cac2",
  null
  
)

export default component.exports